module.exports = __webpack_public_path__ + "img/Jump Casting119.ee699d5b.jpg";